/* Approved pint-glass totals, in cents. No Shopify price override is implied. */
(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.SouvenirPintPricing=api;})(globalThis,()=>{
'use strict';
const tiers=[[1,1562],[2,2497],[4,4592],[6,6600],[12,11999],[24,22825],[48,43340],[120,100100]];
function total(quantity,doubleSided=0){
 if(!Number.isSafeInteger(quantity)||quantity<0||quantity>10000||!Number.isSafeInteger(doubleSided)||doubleSided<0||doubleSided>quantity)throw Error('Choose whole glass quantities, up to 10,000 total. Contact us for larger orders.');
 if(!quantity)return 0;
 let numerator,denominator;
 if(quantity>=120){numerator=100100*quantity;denominator=120;}
 else if(quantity===1){numerator=1562;denominator=1;}
 else{for(let i=1;i<tiers.length;i++){const [hi,pHi]=tiers[i],[lo,pLo]=tiers[i-1];if(quantity<=hi){denominator=hi-lo;numerator=pLo*denominator+(pHi-pLo)*(quantity-lo);break;}}}
 return Math.floor((2*numerator+denominator)/(2*denominator))+220*doubleSided;
}
return {tiers,total};
});
